<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A367GW/tc-custom/9781960332240.jpg?1718282808032" alt="This image is the cover for the book Grim Paradise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grim Paradise
      </h1>
      <p class="bookDescription body article font2">
        <b>The true crime story of a 1960 murder that rocked a tranquil Michigan vacation spot and the search for justice that followed.</b><br/><br/>When widow Frances Lacey was murdered in July 1960 on Mackinac Island, only a few meager clues were found by police, and the case soon turned cold. But more than sixty years later, will those same clues finally solve the mystery? <br/><br/>On July 24, 1960, the quaint charm and serenity of Mackinac, nestled between Michigan’s Upper and Lower Peninsulas, was shattered by Lacey’s brutal death. Despite a massive manhunt and thousands of pages of police reports, her killer was never caught. <br/><br/>Now, in <i>Grim Paradise</i>, true crime author Rod Sadler (<i>Killing Women</i>) delves into the secrets of one of Michigan's most perplexing murder cases. Offering an in-depth and suspenseful account of the long-standing mystery, he poses the question: Could advancements in DNA technology lead to the identity of the Mackinac Island murderer as it did in the case of the Golden State Killer?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rod Sadler
      </h2>
      
      <p class="authorDescription body article">As a decorated police officer, Rod Sadler's ability to document Michigan serial killer Don Miller's case comes from a unique law enforcement perspective. For his entire thirty years in law enforcement, Sadler fostered relationships with many of the key people involved in the investigation, prosecution and even the defense of serial killer Don Miller. Those people include acquaintances of the killer, police officers, detectives, prosecuting attorneys, judges and the killer's own attorney.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2000bf63